import { connect } from 'react-redux';

import CartCalcReselect from 'Reselects/cartcalc';
import NavCartButton from 'Layout/NavBar/NavCartButton';

const mapStateToProps = state => ({ cartCalc: CartCalcReselect(state) });

export default connect(mapStateToProps)(NavCartButton);
